import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import BorseContext from "../../context/borse";
import UserContext from "../../context/user";
import { computePartial } from "../../utils/partial";

const useBorseRequestUpdateMutation = (closeModal, nextSectionIndex) => {
  const { callApi, userProfile } = useContext(UserContext);
  const { setRequests, handleNext, setFormData, setCurrentRequest } = useContext(BorseContext);
  const queryClient = useQueryClient();

  return useMutation(
    ({
      survey,
      campaignId,
      request,
      formData,
      values,
      email,
      phone,
      isRequestForMe,
      studentFirstName,
      studentLastName,
      school,
      lastCompletedStep,
      refundAmount,
    }) =>
      callApi(`/scholarship/request/${campaignId}/${request?.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: request.id,
          ...(email ? { welfareEmail: email } : {}),
          ...(phone ? { welfarePhone: phone } : {}),
          ...(isRequestForMe !== undefined ? { requestForMe: isRequestForMe } : {}),
          ...(studentFirstName ? { studentFirstName } : {}),
          ...(studentLastName ? { studentLastName } : {}),
          ...(school ? { school } : {}),
          ...(refundAmount ? { refundAmount } : {}),
          ...(typeof lastCompletedStep === "number" ? { lastCompletedStep } : {}),
          surveyAnswer: {
            ...computePartial(survey, { ...formData, ...values }),
          },
        }),
      }),
    {
      onSuccess: (data, variables) => {
        if (data?.id) {
          setFormData((current) => ({ ...current, ...variables.values }));
          setRequests((current) =>
            current.map((request) => (request.id === data.id ? data : request))
          );
          setCurrentRequest(data);
          if (closeModal) {
            closeModal();
            setCurrentRequest();
            queryClient.invalidateQueries(["requests", JSON.stringify(userProfile)]);
          } else {
            handleNext(data?.id, nextSectionIndex);
          }
        }
      },
    }
  );
};

export default useBorseRequestUpdateMutation;
